import { Survey as PerformanceSurvey } from '../../performance/survey.model';

export class Survey extends PerformanceSurvey {
    protected static _resource = 'performanceManagement/employees/:employee/surveys';
}
